import { useEffect, useRef } from 'react';

function HtmlWidget(props: any) {
    const {
        value,
        options: { content },
    } = props;
    const divRef = useRef<any>();

    useEffect(() => {
        const htmlString = value ? value : content;
        const fragment = document.createRange().createContextualFragment(htmlString);
        divRef.current.append(fragment);
    }, []);

    return <div ref={divRef} />;
}

export default HtmlWidget;
